export interface Slide {
  index: number
  title: string
  description: string
  iconName: 'FolderOpen' | 'Search' | 'RefreshCw' | 'IndianRupee' | 'Users'
  stat: string
}

export const SLIDES: Slide[] = [
  {
    index: 0,
    title: 'Juggling client data across WhatsApp, email, and spreadsheets',
    description:
      "Your team chases clients for the same documents every quarter. It's scattered, untracked, and embarrassing.",
    iconName: 'FolderOpen',
    stat: 'CA firms waste 6+ hours/week just collecting documents',
  },
  {
    index: 1,
    title: 'No visibility into which client cases are stuck',
    description:
      "You don't know which ITR is pending, which client hasn't responded, or who's going to miss the deadline — until it's too late.",
    iconName: 'Search',
    stat: 'Deadline misses cost CA firms ₹5,000–₹50,000 per penalty notice',
  },
  {
    index: 2,
    title: 'Client onboarding is a manual, repetitive nightmare',
    description:
      'New client? Get ready to collect the same 12 documents, type the same data into 3 different portals, and pray nothing is wrong.',
    iconName: 'RefreshCw',
    stat: 'Average onboarding takes 4–8 hours per client',
  },
  {
    index: 3,
    title: 'Billing is always an afterthought — and underbilled',
    description:
      "You're not tracking time, so you're not billing correctly. You know you're leaving money on the table but have no proof.",
    iconName: 'IndianRupee',
    stat: '70% of CA firms undercharge by 20–40% due to poor tracking',
  },
  {
    index: 4,
    title: 'Your team coordination runs on memory and hope',
    description:
      "Who's doing what? What's the status of Sharma & Sons? You can't answer without calling someone. That's a problem.",
    iconName: 'Users',
    stat: 'Miscommunication is the #1 cause of client churn in CA firms',
  },
]
